module.exports = __webpack_public_path__ + "static/media/addAnotherPaymentMethod.724e0a1c.png";